/** Keep new individual steps visible; never change company scrolling or form values. */
export function resetIndividualStepView(root: HTMLElement | null, loanType: string | undefined) {
  if (!root || loanType !== 'PERSONAL') return;
  const content = root.querySelector<HTMLElement>('.main-content');
  const heading = root.querySelector<HTMLElement>('[data-step-heading]');
  if (content) content.scrollTop = 0;
  heading?.scrollIntoView?.({ block: 'start', behavior: 'auto' });
  heading?.focus({ preventScroll: true });
}
